import { render, staticRenderFns } from "./NotificationCommentPublish.vue?vue&type=template&id=cd1a3b44&scoped=true&lang=pug&"
import script from "./NotificationCommentPublish.vue?vue&type=script&lang=js&"
export * from "./NotificationCommentPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1a3b44",
  null
  
)

export default component.exports